export type LatestRequestOutcome<T> = { stale: true; value?: never } | { stale: false; value: T }

export type UseLatestRequest = {
  run: <T>(request: () => Promise<T>) => Promise<LatestRequestOutcome<T>>
  invalidate: () => void
}

export const useLatestRequest = (): UseLatestRequest => {
  let latestRequestId = 0

  const run = async <T>(request: () => Promise<T>): Promise<LatestRequestOutcome<T>> => {
    const requestId = ++latestRequestId

    try {
      const value = await request()

      return requestId === latestRequestId ? { stale: false, value } : { stale: true }
    } catch (error) {
      if (requestId !== latestRequestId) {
        return { stale: true }
      }

      throw error
    }
  }

  const invalidate = (): void => {
    latestRequestId++
  }

  return { run, invalidate }
}
